import axios from "axios";

// Shared axios instance. withCredentials sends the httpOnly session cookie.
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export default api;
